import {
  EDITOR_TUTORIAL_BUTTON_BOTTOM_PX,
  EDITOR_TUTORIAL_BUTTON_HEIGHT_PX,
  EDITOR_TUTORIAL_CAPTION_GAP_PX,
  EDITOR_TUTORIAL_CAPTION_HEIGHT_PX,
} from '../constants/tutorial'
import { getStickyHeaderSpace } from './stickyHeader'

export const hasRoomForTutorial = (element: Maybe<HTMLElement>) => {
  if (!element) return false

  const { bottom, top } = element.getBoundingClientRect()
  const floor =
    window.innerHeight - EDITOR_TUTORIAL_BUTTON_BOTTOM_PX - EDITOR_TUTORIAL_BUTTON_HEIGHT_PX

  return (
    top >= getStickyHeaderSpace() &&
    bottom + EDITOR_TUTORIAL_CAPTION_GAP_PX + EDITOR_TUTORIAL_CAPTION_HEIGHT_PX <= floor
  )
}

export const findTutorialPlayId = (
  playIds: string[],
  getElement: (playId: string) => Maybe<HTMLElement>,
): Maybe<string> =>
  playIds.find((playId) => hasRoomForTutorial(getElement(playId))) ?? playIds[0] ?? null
